import styled from 'styled-components'
import { borderRadius, colors } from '../../styles/styles'

export const Box = styled.div`
  border: 1px solid ${colors.black20};
  border-radius: ${borderRadius};
`
